import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import Api from "../../services/Api";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faEdit, faHashtag, faTimes } from '@fortawesome/free-solid-svg-icons';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        comercializador: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state.comercializador;
        state[e.target.name] = e.target.value;
        this.setState({ comercializador: state });
    };
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const nit_comercializador = document.getElementById('nit_comercializador').value;
        const nombre = document.getElementById('nombre').value;
        var errores = [];
        if (!nombre) { errores.push("error_nombre"); }
        if (!nit_comercializador) { errores.push("error_nit_comercializador"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        console.log(formData);
        Swal.showLoading();
        authAxios.post("comercializadores/editar", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                Swal.close();
                Swal.fire(
                    'Comercializadoras!',
                    datosRespuesta.data.msj,
                    'success'
                )
                this.props.history.push("/MasterComercializadores");
            })
            .catch(console.log)
    }

    componentDidMount() {
        Swal.showLoading();
        authAxios.get("comercializadores/ver/" + this.props.match.params.id)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, comercializador: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }

    render() {
        const { load, comercializador } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>EDITAR COMERCIALIZADORA</b>)}
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos} id="form">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-2">
                                                    <input type="hidden" name="id" value={this.props.match.params.id} />
                                                    <label htmlFor="nit_comercializador">NIT Comercializadora</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="nit_comercializador" id="nit_comercializador" defaultValue={comercializador.NIT_COMERCIALIZADOR}
                                                            className={((this.verificarError("error_nit_comercializador")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="NIT COMERCIALIZADORA" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el NIT Comercializadora</small>
                                                </div>
                                                <div className="col-md-10">
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="nombre" id="nombre" defaultValue={comercializador.NOMBRE}
                                                        className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="NOMBRE" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-4">
                                                    <label htmlFor="rep_legal">Repr. Legal</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="rep_legal" id="rep_legal" defaultValue={comercializador.REPR_LEGAL}
                                                        className="form-control form-control-sm" placeholder="REPR. LEGAL" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="direccion_comer">Dirección</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="direccion_comer" id="direccion_comer" defaultValue={comercializador.DIRECCION_COMERCIALIZADOR}
                                                        className="form-control form-control-sm" placeholder="DIRECCIÓN" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="correo_electronico_comer">Correo Electrónico</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faAt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="correo_electronico_comer" id="correo_electronico_comer" defaultValue={comercializador.CORREO_ELECTRONICO}
                                                            className="form-control form-control-sm" placeholder="CORREO ELECTRÓNICO" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="resp_comer">Responsable</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="resp_comer" id="resp_comer" defaultValue={comercializador.RESPONSABLE_ACARGO}
                                                        className="form-control form-control-sm" placeholder="RESPONSABLE" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="cargo_resp_comer">Cargo Responsable</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="cargo_resp_comer" id="cargo_resp_comer" defaultValue={comercializador.CARGO_RESPONSABLE}
                                                        className="form-control form-control-sm" placeholder="CARGO RESPONSABLE" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="telefono_resp_comer">Telefono Responsable</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="telefono_resp_comer" id="telefono_resp_comer" defaultValue={comercializador.TELEFONO_RESPONSABLE}
                                                            className="form-control form-control-sm" placeholder="TELEFONO RESPONSABLE" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="correo_electronico_resp_comer">Correo Electrónico Responsable</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faAt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="correo_electronico_resp_comer" id="correo_electronico_resp_comer" defaultValue={comercializador.CORREO_RESPONSABLE}
                                                            className="form-control form-control-sm" placeholder="CORREO ELECTRÓNICO RESP." aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar Comercializadora</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterComercializadores"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;